import { ArrayFieldProps, useArrayField, useFormApi, useFormState } from "informed";
import * as React from "react";
import Collapsible from "react-collapsible";
import { CorrectedArrayFieldProps } from "../../../forms/informedv2/ArrayFieldProps";
import { FormApiFullDefinition, StudyCustomisationModal, StudyCustomisationModalFormValues } from "../StudyCustomisationModal";

export interface CustomisationFieldProps {
    arrayFieldName: string;
    field: string;
    index: number;
    initialValue: any;
    formats: { id: string; name: string }[];
    importances: { id: string; name: string }[];
}

export interface StudyCustomisationFormValues {
    siteItems: StudyCustomisationModalFormValues[];
    subjectItems: StudyCustomisationModalFormValues[];
}

export const CustomisationTab = ({ arrayFieldName, formats, importances }) => {
    const { fields } = useArrayField({ field: arrayFieldName });

    return (
        <>
            {fields.map(({ key, field, index, initialValue }: CorrectedArrayFieldProps<any>) => {
                return (
                    <CustomisationField arrayFieldName={arrayFieldName} key={key} index={index} initialValue={initialValue} field={field} formats={formats} importances={importances} />
                );
            })}
        </>
    );
}

export const CustomisationField = ({ arrayFieldName, initialValue, index, field, formats, importances }: CustomisationFieldProps) => {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const formState = useFormState<StudyCustomisationFormValues>();

    const summaryTagGenerator = () => {
        let summaryTag = "";
        if (formState.values[arrayFieldName]) {
            const itemValues = formState.values[arrayFieldName][index];

            if (!itemValues)
                return "";

            summaryTag += initialValue.isDisplayTextAvailable ? `Display Text of '${itemValues?.displayText}'.` : "";
            summaryTag += initialValue.isFormatAvailable ? ` Format '${itemValues?.format?.name}'.` : "";
            summaryTag += initialValue.isMinAndMaxLengthAvailable ? ` Length Range '${itemValues?.minimumLength}' - '${itemValues?.maximumLength}'.` : "";
            summaryTag += initialValue.isMinAndMaxValueAvailable ? ` Value Range '${itemValues?.minimumValue}' - '${itemValues?.maximumValue}'.` : "";
            summaryTag += initialValue.isImportanceAvailable ? ` ${itemValues.importance?.name}.` : "";
            summaryTag += initialValue.isUnitTypeAvailable ? ` ${itemValues.unitType?.name}.` : "";
        }

        return summaryTag;
    }

    const trigger =
        <span>
            <b>{initialValue.name}</b> {!isOpen ? summaryTagGenerator() : null}
        </span>;

    return (<Collapsible trigger={trigger} onTriggerOpening={() => setIsOpen(true)} onTriggerClosing={() => setIsOpen(false)} overflowWhenOpen="visible">
        <StudyCustomisationModal show={showModal} itemId={initialValue.itemId} onClose={() => setShowModal(false)} fieldPrefix={field} formatOptions={formats} importanceOptions={importances} />
    </Collapsible>);
}

